<template>
  <OmtLayoutContainer>
    <OmtRow mb="32px">
      <OmtTypography as="h1-bold"> Nova solicitação </OmtTypography>
    </OmtRow>
    <OmtRow mb="16px">
      <OmtTypography as="p1" color="var(--colors-light-primary-gray2)"> Assunto da solicitação: </OmtTypography>
    </OmtRow>
    <OmtRow v-if="!loading">
      <CStack mb="24px">
        <OmtRow v-for="(option, index) in subjectOptions" :key="index">
          <CBox>
            <CFlex justify="space-between" align-items="center" cursor="pointer" mb="8px">
              <OmtRadio
                @click="onSelectedSubject(option.value)"
                :value="String(option.value)"
                :isChecked="subjectId === option.value"
                :reverse="true"
                name="distance"
              >
                <OmtTypography as="p3"> {{ option.label }} </OmtTypography>
              </OmtRadio>
            </CFlex>
          </CBox>
        </OmtRow>
      </CStack>
    </OmtRow>

    <template v-if="!loading && subjectId">
      <OmtRow mb="16px">
        <OmtTypography as="p1" color="var(--colors-light-primary-gray2)">
          Beneficiário que realizará o procedimento
        </OmtTypography>
      </OmtRow>
      <OmtRow>
        <Options
          id="optRecipientId"
          name="optRecipient"
          :solid="true"
          :preSelected="beneficiary"
          :options="beneficiaries"
          :onSelection="onSelectedBeneficiary"
          placeholder="Selecione o Beneficiário"
          class="options-requests"
        />
      </OmtRow>
    </template>
    <OmtRow mt="48px" justifyContent="center">
      <OmtButton :w="['100%', '308px !important']" @click="next" :disabled="disableButton"> Continuar </OmtButton>
    </OmtRow>
  </OmtLayoutContainer>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import Options from "@/components/Molecules/Options";
import FixedButtonRow from "@/components/Atoms/FixedButtonRow/index.vue";

export default {
  name: "CreateRequest",
  components: {
    Options,
    FixedButtonRow
  },
  data() {
    return {
      beneficiary: "",
      loading: true,
      subjectId: 0,
      subject: {},
      requireAuth: true
    };
  },
  computed: {
    ...mapState("request", ["addPermission", "beneficiaries", "newRequest", "subjectOptions"]),
    ...mapState("saude", ["vinculo"]),
    queryOrder() {
      return this.$route.query?.tipo === "pedido" ?? "";
    },
    queryOthers() {
      return this.$route.query?.outros ?? "";
    },
    attchamentDsc() {
      if (!this.subject?.attchamentDsc?.length) return [];
      const showMore = this.subject.attchamentDsc.length > 2;
      const attchamentDsc = [...this.subject.attchamentDsc.slice(0, 2).map(a => a.dsc)];
      if (showMore) attchamentDsc[1] = `${attchamentDsc[1]} ...`;
      return attchamentDsc;
    },
    disableButton() {
      if (this.subject?.beneficiaryType) {
        return !this.subjectId || !this.beneficiary;
      }
      return !this.subjectId;
    },
    isOtherMatters() {
      return this.subject?.outros || false;
    }
  },
  methods: {
    ...mapActions("request", ["fetchBeneficiaries", "fetchSubjectOptions"]),
    ...mapMutations("request", ["SET_BENEFICIARY", "SET_SUBJECT"]),
    onSelectedSubject(id) {
      if (id) {
        this.subjectId = id;
        this.subject = this.subjectOptions.find(s => s.value === id);
      }
    },
    onSelectedBeneficiary(beneficiary) {
      if (beneficiary) {
        this.beneficiary = beneficiary;
      }
    },
    next() {
      if (this.disableButton) return;
      this.SET_SUBJECT(this.subjectId);
      this.SET_BENEFICIARY(this.subject?.beneficiaryType ? this.beneficiary : "");

      if (this.queryOrder) {
        this.$router.push({ name: "request.upload.documents", query: { tipo: "pedido" } });
        return;
      }

      this.$router.push({
        name: "request.info"
      });
    }
  },
  async mounted() {
    let redirect = false;
    const subject = this.subjectOptions.find(s => s.value === this.newRequest.subject);
    this.requireAuth = !!subject?.authorizationService;
    try {
      this.$root.$emit("show-loading");
      this.loading = true;
      if (!this.addPermission) this.$router.replace("/solicitacoes");
      await Promise.all([this.fetchBeneficiaries(), this.fetchSubjectOptions()]);
      if (this.newRequest?.subject) this.onSelectedSubject(this.newRequest.subject);
      if (this.newRequest?.beneficiary) this.onSelectedBeneficiary(this.newRequest.beneficiary);

      if (this.queryOrder) {
        const loggedBeneficiary = this.beneficiaries.find(b => {
          return b.id === this.vinculo;
        });

        if (("logado", loggedBeneficiary)) {
          this.onSelectedSubject(1);
          this.onSelectedBeneficiary(loggedBeneficiary.value);
          this.next();
        }
      }

      // Caso tenha query outros e já tenha os dados necessários, redireciona para a página de observação
      if (this.queryOthers && this.newRequest && this.subject) {
        redirect = true;
        this.$router.push({
          name: "request.observation.outros",
          params: {
            requireAuth: !!this.subject.authorizationService
          }
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.loading = false;
      // Caso não tenha redirecionado, esconde o loading
      if (!redirect) this.$root.$emit("hide-loading");
    }
  }
};
</script>

<style scoped>
.list li {
  font-size: 12px;
}

.options-requests ::v-deep select {
  font-size: 14px !important;
  font-weight: 700;
}
</style>
